
import * as ReactDOM from 'react-dom';
import { notifierFacet } from './createStore';

/**
 * Creates an alternate store notifier which uses React DOM batched updates.
 * This can help reduce re-renders caused by cascading store updates.
 * @beta
 */
export function createWebStoreNotifier(): typeof notifierFacet.type {
  let timeoutId: number | null = null;

  return (notify: () => void) => {
    if (timeoutId === null) {
      timeoutId = window.setTimeout(() => {
        timeoutId = null;

        ReactDOM.unstable_batchedUpdates(notify);
      }, 0);
    }
  };
}
